export default "<app-problem-list></app-problem-list>\r\n";